export const colorsBg = {
  white: ['bg-white text-black'],
  light: ['bg-gray-100 text-black'],
  success: ['bg-teal-600 text-white'],
  danger: ['bg-rose-600 text-white'],
  warning: ['bg-amber-500 text-white'],
  info: ['bg-cyan-700 text-white']
}

export const colorsBorders = {
  white: ['border-gray-300'],
  light: ['border-gray-200'],
  success: ['border-teal-700'],
  danger: ['border-rose-700'],
  warning: ['border-amber-600'],
  info: ['border-cyan-800']
}

export const colorsText = {
  light: ['text-gray-700'],
  success: ['text-teal-600'],
  danger: ['text-rose-600'],
  warning: ['text-amber-600'],
  info: ['text-cyan-700']
}

export const colorsOutline = {
  white: [...colorsBg.white, ...colorsBorders.white],
  light: [...colorsText.light, ...colorsBorders.light],
  success: [...colorsText.success, ...colorsBorders.success],
  danger: [...colorsText.danger, ...colorsBorders.danger],
  warning: [...colorsText.warning, ...colorsBorders.warning],
  info: [...colorsText.info, ...colorsBorders.info]
}

export const colorsButtons = {
  white: ['hover:bg-gray-50', ...colorsBg.white, ...colorsBorders.white],
  light: ['hover:bg-gray-200', ...colorsBg.light, ...colorsBorders.light],
  success: ['hover:bg-teal-700', ...colorsBg.success, ...colorsBorders.success],
  danger: ['hover:bg-rose-700', ...colorsBg.danger, ...colorsBorders.danger],
  warning: ['hover:bg-amber-600', ...colorsBg.warning, ...colorsBorders.warning],
  info: ['hover:bg-cyan-800', ...colorsBg.info, ...colorsBorders.info]
}

export const colorsButtonsOutline = {
  white: colorsButtons.white,
  light: ['hover:bg-gray-100', ...colorsText.light, ...colorsBorders.light],
  success: ['hover:bg-teal-600 hover:text-white', ...colorsText.success, ...colorsBorders.success],
  danger: ['hover:bg-rose-600 hover:text-white', ...colorsText.danger, ...colorsBorders.danger],
  warning: ['hover:bg-amber-500 hover:text-white', ...colorsText.warning, ...colorsBorders.warning],
  info: ['hover:bg-cyan-700 hover:text-white', ...colorsText.info, ...colorsBorders.info]
}
